import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.includes.js";
export function isExternalScriptsDisabled(provider) {
  if (typeof window === "undefined") return false;
  const noExternalScripts = new URL(location.href).searchParams.get("no-external-scripts");
  if (noExternalScripts === null) return false;
  return noExternalScripts === "" || (noExternalScripts === null || noExternalScripts === void 0 ? void 0 : noExternalScripts.includes(provider));
}